const possibleWelcomeMessages: string[] = [
  "Welcome",
  "Bienvenue",
  "Bienvenido",
  "Willkommen",
]; //, "欢迎"];
export default possibleWelcomeMessages;
